/**
 * A CHAVE NO CABEÇALHO DA LISTA (R06, p.69): "Mostrar estornados · 1". Efeito
 * imediato, como toda chave (p.24): ligar mostra, desligar esconde, sem botão
 * de aplicar. Ligada, fica na tinta laranja do filtro aplicado (p.16).
 *
 * `role="switch"` com `aria-checked`: o leitor de tela diz "ligado" e
 * "desligado", e o rótulo diz o que ela liga.
 */
export function ChaveDeFiltro({
  rotulo,
  ligada,
  aoMudar,
}: {
  readonly rotulo: string;
  readonly ligada: boolean;
  readonly aoMudar: (ligada: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligada}
      onClick={() => {
        aoMudar(!ligada);
      }}
      className={`inline-flex h-[var(--controle-p)] shrink-0 cursor-pointer items-center gap-2 rounded-pill border pr-3 pl-1 txt-botao transition-colors duration-[var(--mov-padrao)] ${
        ligada ? 'border-marca bg-marca-fundo text-marca-texto' : 'border-borda bg-card text-tinta-secundaria hover:border-borda-forte'
      }`}
    >
      <span
        aria-hidden="true"
        className={`relative h-6 w-10 shrink-0 rounded-pill transition-colors duration-[var(--mov-padrao)] ${ligada ? 'bg-acao' : 'bg-borda-forte'}`}
      >
        <span
          className={`absolute top-1 left-1 size-4 rounded-pill bg-branco shadow-superficie transition-transform duration-[var(--mov-padrao)] ease-[var(--mov-padrao-curva)] motion-reduce:transition-none ${
            ligada ? 'translate-x-4' : ''
          }`}
        />
      </span>
      {rotulo}
    </button>
  );
}
